import React from "react";
import styles from "pages/Welcome/style.module.scss";

/**
 * Top-right tab review count pill; opens reviews drawer when onClick is provided.
 */
export default function WelcomeTabReviewCountButton({
  label,
  onClick,
  reviewCount,
}) {
  if (!label) {
    return null;
  }
  const clickable =
    typeof onClick === "function" &&
    reviewCount != null &&
    Number(reviewCount) > 0;
  const className = [
    styles.welcomeGeneralSummaryHierarchicalTabReviewCount,
    clickable ? styles.welcomeGeneralSummaryHierarchicalTabReviewCountClickable : "",
  ]
    .filter(Boolean)
    .join(" ");

  if (!clickable) {
    return <span className={className}>{label}</span>;
  }

  return (
    <button
      type="button"
      className={className}
      onClick={onClick}
      aria-label={label}
    >
      {label}
    </button>
  );
}
